import { Outlet, useNavigate } from 'react-router';
import { Box, CssBaseline } from '@mui/material';
import { useIdleTimer } from 'react-idle-timer';
import { Navbar } from '../possibly-stateful-components/NavBar/NavBar.tsx';
import { useGetCurrentUser, useSignOut } from '../hooks/auth.ts';
import '../possibly-stateful-components/NavBar/possibly-stateful-components/PortalNavBar/PortalNavBar.scss';

export function Root() {
  const signOut = useSignOut();
  const navigate = useNavigate();
  const { data: user } = useGetCurrentUser();

  const onIdle = () => {
    if (user?.userId) {
      void navigate('/');
      signOut.mutate();
    }
  };
  //1 hour timer
  useIdleTimer({
    onIdle,
    timeout: 60 * 60 * 1000,
    throttle: 500,
  });
  return (
    <>
      <CssBaseline />
      <Box
        data-testid="root"
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Navbar />
        <div
          style={{
            flexGrow: 1,
            height: 1,
            minHeight: 'fit-content',
            position: 'relative',
          }}
        >
          <Outlet />
        </div>
      </Box>
    </>
  );
}
